<template>
	<el-dialog v-model="innerVisible" :close-on-click-modal="false"  :title="title" width="88%"  custom-class="zero-padding-modal" append-to-body @opened="openedInit" @closed="closeDeal">
		<div class="assemble-choose-material-modal-content">
			<div class="modal-content-top">
				<el-form :model="query" label-width="100px"><el-row>
					<el-col :span="8">
					  <el-form-item label="品号:">
					    <el-input v-model="query.Code" clearable placeholder="请输入品号" />
					  </el-form-item>
					</el-col>
					<el-col :span="8">
					  <el-form-item label="容器编号:">
					    <el-input v-model="query.ContainerCode" clearable placeholder="请输入容器编号" />
					  </el-form-item>
					</el-col>
					
					<template v-if="!queryHidden">
					<el-col :span="8">
					  <el-form-item label="库位编号:">
					    <el-input v-model="query.LocationCode" clearable placeholder="请输入库位编号" />
					  </el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item label="项目编号:">
							<el-input v-model="query.ProjectCode" clearable placeholder="请输入项目编号" />
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item label="所属库区:">
							<el-select v-model="query.AreaID" placeholder="请选择所属库区" style="width: 100%;">
								<el-option v-for="item in selectOptions.areas" :key="item.id" :label="item.areaName" :value="item.id" />
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="8">
					  <el-form-item label="规格型号:">
					    <el-input v-model="query.SpecificationModel" clearable placeholder="请输入规格型号" />
					  </el-form-item>
					</el-col>
          <el-col :span="8">
						<el-form-item label="屏蔽库位:">
							<el-select v-model="query.ZpLocation" placeholder="请选择是否屏蔽装备库位" style="width: 100%;">
								<el-option v-for="item in yesOrNolist" :key="item.value" :label="item.name" :value="item.value" />
							</el-select>
						</el-form-item>
					</el-col>
					</template>
					<el-col :span="8">
					  <el-form-item label-width="20px">
					    <el-button type="primary" icon="el-icon-search" @click="onQuery">查询</el-button>
					    <el-button icon="el-icon-refresh-right" @click="onReset">重置</el-button>
							<el-button type="text" @click="queryHidden=!queryHidden">{{queryHidden?'展开':'收起'}}<i :class="['el-icon--right',queryHidden?'el-icon-arrow-down':'el-icon-arrow-up']"></i></el-button>
					  </el-form-item>
					</el-col>
				</el-row></el-form>
			</div>
			<div class="modal-content-list">
				<div class="list-padding">
					<div v-if="!showChoosen">
						<!-- :row-class-name="rowClassName" -->
						<el-table :data="list" border row-key="id" ref="choosetable" >
							<el-table-column align="center" width="60">
								<template #header>
									<el-checkbox v-model="checkAll" :indeterminate="checkAllIndeterminate" @change="onMaterialSelectAll" />
								</template>
								<template #default="scope">
									<el-checkbox v-model="scope.row.checked" :disabled="scope.row.currentQuantity == 0" @change="onMaterialSelect($event,scope.row)" />
								</template>
							</el-table-column>
							<!-- <el-table-column type="selection" width="60" align="center" :selectable="selectableFunction"></el-table-column> -->
							<el-table-column label="序号" align="center" width="60">
								<template #default="scope">
									{{(queried.PageNo-1)*queried.PageSize+(scope.$index+1)}}
								</template>
							</el-table-column>
							
							<el-table-column label="项目编号" prop="projectCode" align="center" width=""/>
							<el-table-column label="品号" prop="code" align="center" width=""/>
							<el-table-column label="品名" prop="name" align="center" width="250" />
							<el-table-column label="规格型号" prop="specificationModel" align="center" width="350"/>
							<el-table-column label="单位" prop="unit" align="center" width="60"/>
							<el-table-column label="容器编号" prop="containerCode" align="center" width=""/>
							<el-table-column label="库位编号" prop="locationCode" align="center" width=""/>
							<el-table-column label="出库数" width="" align="center">
							  <template #default="scope">
									<el-input-number v-model="scope.row.outNum" :min="0" :max="scope.row.currentQuantity" size="small" />
							  </template>
							</el-table-column>
							<!-- <el-table-column label="库位状态" align="center" width="">-->

              				<!-- <el-table-column label="库位状态" align="center" width="">
							  <template #default="scope">
							    <span>{{ localStatus(scope.row.locationStatus) }}</span>
							  </template>
							</el-table-column> -->
							<el-table-column
								label="库存数"
								prop="currentQuantity"
								align="center"
								width=""
							/>
						</el-table>
          </div>
          <div v-else>
            <el-table :data="choosen" border row-key="id">
              <el-table-column label="序号" align="center" width="60">
                <template #default="scope">{{ scope.$index + 1 }}</template>
              </el-table-column>
              <el-table-column
                label="品号"
                prop="code"
                align="center"
                width=""
              />
              <el-table-column label="品名" prop="name" align="center" />
              <el-table-column
                label="规格型号"
                prop="specificationModel"
                align="center"
              />
              <el-table-column
                label="单位"
                prop="unit"
                align="center"
                width="60"
              />
              <el-table-column
                label="容器编号"
                prop="containerCode"
                align="center"
                width=""
              />
              <el-table-column
                label="库位编号"
                prop="locationCode"
                align="center"
                width=""
              />
              <!-- <el-table-column label="库位状态" align="center" width="">
							  <template #default="scope">
							    <span>{{ localStatus(scope.row.locationStatus) }}</span>
							  </template>
							</el-table-column> -->
              <el-table-column label="出库数" width="" align="center">
							  <template #default="scope">
									<el-input-number v-model="scope.row.outNum" :min="0" :max="scope.row.currentQuantity" size="small" />
							  </template>
							</el-table-column>
              <el-table-column
                label="库存数"
                prop="currentQuantity"
                align="center"
                width=""
              />
              <el-table-column label="操作" width="80" align="center">
                <template #default="scope">
                  <el-button
                    type="danger"
                    size="small"
                    @click="onDel(scope.$index)"
                    >删除</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
      <div
        v-if="!showChoosen"
        style="display: flex; justify-content: flex-end; padding-top: 8px"
      >
        <el-pagination
          :background="true"
          :total="total"
          :page-sizes="[10, 20, 100,500,1000]"
          v-model:current-page="queried.PageNo"
          v-model:page-size="queried.PageSize"
          layout="total, sizes, prev, pager, next, jumper"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
      </div>
    </div>

    <template #footer>
      <span class="dialog-footer">
        <el-button @click="onBtnClose">取 消</el-button>
        <el-button
          :disabled="!showChoosen && choosen.length === 0"
          @click="onChangeShowChoosen"
          >已选物料({{ choosen.length }})</el-button
        >
        <el-button :disabled="choosen.length === 0" type="primary" @click="onOk"
          >确 定</el-button
        >
      </span>
    </template>
  </el-dialog>
</template>

<script setup>
import {
  defineEmits,
  ref,
  reactive,
  watch,
  toRefs,
  getCurrentInstance
} from "vue";
import { getStorageInfoShelvesList } from "@/service/main/warehouse";
import {
  getManualOutstock,
  BlackStockListPage
} from "@/service/main/invoices/allocateOrder";
import { localStatus } from "../../switchCase";
const defaultQuery = {
  ContainerCode: "",
  LocationCode: "",
  ProjectCode: "",
  Code: "",
  AreaID: -10
};
const pagination = {
  PageNo: 1,
  PageSize: 10
};

const instance = getCurrentInstance();

const emits = defineEmits(["update:visible", "callback"]);

const props = defineProps({
  visible: {
    type: Boolean,
    default: false
  },
  projectCode: {
    type: String,
    default: ""
  }
});
const { visible, projectCode } = toRefs(props);

const innerVisible = ref(false);
const title = ref("物料选择");

const queryHidden = ref(true);
const query = reactive({ ...defaultQuery });
const queried = reactive({ ...pagination });
const selectOptions = reactive({
  areas: []
});
const list = ref([]);
const yesOrNolist = ref([{value:1,name:'是'},{value:0,name:'否'}]);
const total = ref(0);
const choosen = ref([]);
const showChoosen = ref(false);
const checkAll = ref(false);
const checkAllIndeterminate = ref(false);
// // 新增/修改弹框数量为0不可选择
// const selectableFunction = function(row)  {
//     if (row.currentQuantity == 2) {
// 		// row.checked = false
//         return false
//     } else {
//         return true
//     }
// }
// const rowClassName= function({row}) {
// 	// 通过自定义类名来禁用选择框
// 	console.log('row111',row.currentQuantity)
// 	if (row.currentQuantity == 2) {
// 		return 'row-disable-selection';
//     }
// }
watch(
  visible,
  function (newVal) {
    if (innerVisible.value !== newVal) {
      innerVisible.value = newVal;
    }
  },
  { immediate: true }
);
watch(innerVisible, function (newVal) {
  if (visible.value !== newVal) {
    emits("update:visible", newVal);
  }
});

const closeDeal = function () {
  list.value = [];
  total.value = 0;
  choosen.value = [];
  showChoosen.value = false;
  checkAll.value = false;
  checkAllIndeterminate.value = false;
};

const onBtnClose = function () {
  selfClose();
};

const selfClose = function () {
  innerVisible.value = false;
};

const openedInit = function () {
  //console.log('projectCode',projectCode.value)
  defaultQuery.ProjectCode = projectCode.value;

  getAreaOptions();
  reset();
};

const getAreaOptions = function () {
  if (selectOptions.areas.length <= 0) {
    getStorageInfoShelvesList().then((res) => {
      let arr = res.data || [];
      if (arr.length > 0) {
        arr.unshift({
          id: -10,
          areaName: "全部"
        });
      }
      selectOptions.areas = arr;
    });
  }
};

const onQuery = function () {
  newList();
};

const onReset = function () {
  reset();
};

const newList = function () {
  for (let name in query) {
    queried[name] = query[name];
  }
  for (let name in pagination) {
    queried[name] = pagination[name];
  }
  getList();
};

const getList = function(){
	
	BlackStockListPage(queried).then((res) => {
		list.value = res.data.rows
		list.value.forEach(item=>{
			item.checked = false
      item.outNum = 0
		})
		// console.log('list.value',list.value)
		total.value = res.data.totalRows
		setMaterialsChoosen()
	}).catch((err)=>{
		console.log(err)
	})
}

const reset = function () {
  for (let name in defaultQuery) {
    query[name] = defaultQuery[name];
  }
  newList();
};

const handleSizeChange = function (pageSize) {
  queried.PageNo = 1;
  queried.PageSize = pageSize;
  getList();
};

const handleCurrentChange = function (page) {
  queried.PageNo = page;
  getList();
};
const onMaterialSelectAll = function (value) {
  checkAllIndeterminate.value = false;
  list.value.forEach((listItem) => {
    if (checkAll.value) {
      listItem.checked = true;
      addChosen(listItem);
    } else {
      listItem.checked = false;
      reduceChoosen(listItem);
    }
  });
};

const onMaterialSelect = function (val, obj) {
  if (val) {
    addChosen(obj);
  } else {
    reduceChoosen(obj);
  }
  setCheckedAll();
};
const addChosen = function(obj) {
	let f = checkInChoosen(obj)
	if (f===-1 && obj.currentQuantity!=0) {
		choosen.value.push(obj)
	}
}

const reduceChoosen = function (obj) {
  let n = checkInChoosen(obj);
  if (n >= 0) {
    choosen.value.splice(n, 1);
  }
};

const checkInChoosen = function (obj) {
  let res = -1;
  for (let i = 0; i < choosen.value.length; i++) {
    if (choosen.value[i].id === obj.id) {
      res = i;
      break;
    }
  }
  return res;
};

const setCheckedAll = function () {
  let c = 0;
  list.value.forEach((listItem) => {
    if (listItem.checked) {
      c++;
    }
  });
  if (c === 0) {
    checkAll.value = false;
    checkAllIndeterminate.value = false;
  } else if (c === list.value.length) {
    checkAll.value = true;
    checkAllIndeterminate.value = false;
  } else {
    checkAll.value = false;
    checkAllIndeterminate.value = true;
  }
};

const setMaterialsChoosen = function () {
  list.value.forEach((listItem) => {
    let f = checkInChoosen(listItem);
    if (f === -1) {
      listItem.checked = false;
    } else {
      listItem.checked = true;
    }
  });
  setCheckedAll();
};

const handleSelectionChange = (val) => {
  choosen.value = val;
};

const onChangeShowChoosen = function () {
  showChoosen.value = !showChoosen.value;
  if (showChoosen.value !== true) {
    setMaterialsChoosen();
  }
};

const onDel = function (index) {
  choosen.value.splice(index, 1);
};

const onOk = function () {
  selfClose();
  emits("callback", choosen.value);
};
</script>

<style lang="less" scoped>
.assemble-choose-material-modal-content {
  height: 70vh;
  display: flex;
  flex-direction: column;
  .modal-content-top {
    padding: 20px 16px 0 16px;
    flex-shrink: 0;
  }
  .modal-content-list {
    flex-grow: 1;
    height: 1px;
    overflow: auto;
    .list-padding {
      padding: 0 16px;
    }
  }
}

</style>